import { api } from "@/lib/api";

export const lawyerApi = api;

export const fetchDashboard = () => lawyerApi.get("/lawyer/dashboard").then((r) => r.data);
export const fetchProfile = () => lawyerApi.get("/lawyer/me").then((r) => r.data);
export const updateProfile = (payload) => lawyerApi.patch("/lawyer/me", payload).then((r) => r.data);
export const setAvailability = (payload) => lawyerApi.post("/lawyer/availability", payload).then((r) => r.data);

export const fetchConsultations = (params) => lawyerApi.get("/lawyer/consultations", { params }).then((r) => r.data);
export const acceptConsultation = (cid) => lawyerApi.post(`/lawyer/consultations/${cid}/accept`).then((r) => r.data);
export const rejectConsultation = (cid, reason = "") => lawyerApi.post(`/lawyer/consultations/${cid}/reject`, { reason }).then((r) => r.data);
export const markNoShow = (cid) => lawyerApi.post(`/lawyer/consultations/${cid}/no-show`).then((r) => r.data);

export const fetchEarnings = (params) => lawyerApi.get("/lawyer/earnings", { params }).then((r) => r.data);

// Phase-3B: Availability Pulse
export const startPulse = (duration_minutes = 15, message = "") =>
  lawyerApi.post("/lawyer/pulse", { duration_minutes, message }).then((r) => r.data);
export const stopPulse = () => lawyerApi.delete("/lawyer/pulse").then((r) => r.data);

// Phase-3B: AI memo background job
export const enqueueAiSummary = (cid) =>
  lawyerApi.post(`/consultations/${cid}/ai-summary/enqueue`).then((r) => r.data);
export const aiSummaryStatus = (cid) =>
  lawyerApi.get(`/consultations/${cid}/ai-summary/status`).then((r) => r.data);

// Live runtime + reviews + AI summary
export const startConsultation = (cid) => lawyerApi.post(`/consultations/${cid}/start`).then((r) => r.data);
export const completeConsultation = (cid) => lawyerApi.post(`/consultations/${cid}/complete`).then((r) => r.data);
export const fetchLawyerReviews = (params) => lawyerApi.get("/lawyer/reviews", { params }).then((r) => r.data);
export const generateAiSummary = (cid) => lawyerApi.post(`/consultations/${cid}/ai-summary`).then((r) => r.data);
export const updateAiSummary = (cid, payload) => lawyerApi.patch(`/consultations/${cid}/ai-summary`, payload).then((r) => r.data);
export const readAiSummary = (cid) => lawyerApi.get(`/consultations/${cid}/ai-summary`).then((r) => r.data);
export const fetchRuntimeState = (cid) => lawyerApi.get(`/consultations/${cid}/runtime`).then((r) => r.data);
